import React, { useState } from 'react';
import { Send, Plus } from 'lucide-react';
import '../styles/ChatInput.css';

const ChatInput = ({ onSendMessage, onNewChat, isLoading }) => {
  const [inputValue, setInputValue] = useState('');

  const handleSend = () => {
    // Permitir enviar si hay texto O si no hay texto (el ChatContainer decidirá)
    if (!isLoading) {
      onSendMessage(inputValue.trim());
      setInputValue('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="chat-input-wrapper">
      <div className="chat-input-container">
        <button
          className="chat-action-button new-chat-button"
          onClick={onNewChat}
          title="Iniciar nueva conversación"
          disabled={isLoading}
        >
          <Plus size={20} />
        </button>

        <textarea
          className="chat-input"
          placeholder="Escribí tu consulta... (Shift+Enter para nueva línea)"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isLoading}
          rows={1}
        />

        <button
          className="chat-action-button send-button"
          onClick={handleSend}
          disabled={isLoading}
          title="Enviar mensaje"
        >
          {isLoading ? (
            <div className="spinner"></div>
          ) : (
            <Send size={20} />
          )}
        </button>
      </div>
      <p className="chat-input-hint">Presioná Enter para enviar • Shift+Enter para nueva línea</p>
    </div>
  );
};

export default ChatInput;
